module.exports = __webpack_public_path__ + "static/media/alien.16e95908.svg";